import { EDisableRule, EPermissionType } from "../../features/resources/services/types/enum";
import { ResourceEntity } from "../../features/resources/services/types/resourceEntity";
import { PERMISSION_DESCRIPTION, RULE_DESCRIPTION } from "../../shared/constants/permission";
import { EPreSelectedResource } from "../../shared/types/enums/preSelectedResourceEnum";

export function getUidSerieMasterByUidOccurrence(uid: string) {
  let result = uid;
  // with series master, the YH, YL, M, and D fields of uid MUST all be zero
  // YH Yl M D is byte beetween 17 to 20
  // YH: 1 bytes ->  2 char in hex string
  // YL: 1 bytes ->  2 char in hex string
  // M: 1 bytes ->  2 char in hex string
  // D: 1 bytes ->  2 char in hex string
  result = replaceAt(uid, 32, "00000000");
  return result;
}

export function replaceAt(_string: string, index: number, _replace: string) {
  _string = _string.slice(0, index) + _string.slice(index + _replace.length);
  return _string.substring(0, index) + _replace + _string.substring(index);
}

export function getMessageUrl(itemId: string): string {
  let resVersion = Office.MailboxEnums.RestVersion.v2_0;
  let strRestid = Office.context.mailbox.convertToRestId(itemId, resVersion);
  let getMessageUrl = "https://graph.microsoft.com/v1.0/me/events/" + strRestid + "?$select=iCalUId,originalStart";
  return getMessageUrl;
}

export function mapPermissionMessage(
  resource: ResourceEntity,
  isRecurring: boolean
): { type: EPreSelectedResource; message: string } | null {
  const permissions = resource.availability.permissions(isRecurring);
  let temp: { type: EPreSelectedResource; message: string } | null = null;

  if (permissions?.length) {
    for (const permission of permissions) {
      switch (permission) {
        case EPermissionType.OccurrencceExceedCapacity:
        case EPermissionType.OccurenciesWithConflicts:
        case EPermissionType.CanBookByExchangeByRule:
        case EPermissionType.DeclinedByInPolicy:
        case EPermissionType.DeclinedByOutPolicy:
        case EPermissionType.VRConfigWrong:
        case EPermissionType.ViolatePriority:
        case EPermissionType.ExceedCapacity:
        case EPermissionType.CannotBookByExchangeByRule:
        case EPermissionType.Unavailable:
          temp = { type: EPreSelectedResource.Removed, message: PERMISSION_DESCRIPTION[permission] };
          break;
        case EPermissionType.OpenHours:
        case EPermissionType.CloseDate:
          temp = { type: EPreSelectedResource.Removed, message: RULE_DESCRIPTION[EDisableRule.DisableOpeningHours] };
          break;
        case EPermissionType.DelegateByInOutPolicy:
          temp = { type: EPreSelectedResource.Warning, message: PERMISSION_DESCRIPTION[permission] };
          break;
        default:
          break;
      }
      if (temp !== null) {
        break;
      }
    }
  }
  return temp;
}

declare const Office: any;

/**
 * Get organizer from appointment item (supports shared mailbox)
 * Returns organizer email and name, with fallback to userProfile if not available
 */
export function getOrganizerFromAppointment(
  appCompose: Office.AppointmentCompose
): Promise<{ email: string; name: string }> {
  return new Promise((resolve) => {
    const userProfile = Office.context.mailbox.userProfile;
    appCompose.organizer.getAsync((result: Office.AsyncResult<Office.EmailAddressDetails>) => {
      const email =
        result.status === Office.AsyncResultStatus.Succeeded && result.value
          ? result.value.emailAddress?.toLowerCase() || ""
          : Office.context.mailbox.userProfile.emailAddress?.toLowerCase() || "";
      let name =
        result.status === Office.AsyncResultStatus.Succeeded && result.value
          ? result.value.displayName || ""
          : Office.context.mailbox.userProfile.displayName || "";
      //new outlook app cannot get displayName, so we use email to get displayName
      if (name?.toLowerCase() === userProfile.emailAddress?.toLowerCase()) {
        name = userProfile.displayName || name;
      }
      resolve({ email, name });
    });
  });
}

/**
 * Get organizer email from appointment item (supports shared mailbox)
 * Returns organizer email only, with fallback to userProfile if not available
 */
export function getOrganizerEmailFromAppointment(appCompose: Office.AppointmentCompose): Promise<string> {
  return new Promise((resolve) => {
    appCompose.organizer.getAsync((result: Office.AsyncResult<Office.EmailAddressDetails>) => {
      const email =
        result.status === Office.AsyncResultStatus.Succeeded && result.value
          ? result.value.emailAddress?.toLowerCase() || ""
          : Office.context.mailbox.userProfile.emailAddress?.toLowerCase() || "";
      resolve(email);
    });
  });
}

export const MAP_DAY_OF_WEEK: Record<string, string> = {
  sun: "Sunday",
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
};
